import Header from "../components/Header";

const sections = [
  {
    title: "Éditeur du site",
    body: "Lantouraj — annuaire de spécialistes pour enfants en Guadeloupe. Contact : maryannagasper@gmail.com. Directrice de la publication : Mary-Anna Gasper.",
  },
  {
    title: "Données collectées",
    body: "Professionnels : nom, spécialité, commune, coordonnées professionnelles (téléphone, email), présentation, langues parlées et statut de disponibilité. Parents/visiteurs : aucun compte requis ; les coordonnées saisies dans le formulaire de contact sont transmises au professionnel par email et ne sont pas conservées dans notre base. Les messages de signalement sont conservés jusqu'à leur traitement.",
  },
  {
    title: "Aucune donnée médicale",
    body: "Lantouraj ne collecte, ne stocke et ne traite aucune donnée médicale concernant les enfants. Nous vous demandons de ne jamais inclure d'information de santé dans les formulaires du site.",
  },
  {
    title: "Finalité et base légale",
    body: "La publication des informations professionnelles repose sur le consentement explicite du professionnel, recueilli lors de son inscription ou consigné par l'administratrice (date de consentement enregistrée). Le traitement des signalements repose sur l'intérêt légitime de maintenir des informations fiables.",
  },
  {
    title: "Durée de conservation",
    body: "Les fiches professionnelles sont conservées jusqu'à demande de retrait. Un statut de disponibilité non mis à jour depuis 30 jours bascule automatiquement en « À confirmer ». Les comptes peuvent être supprimés sur simple demande.",
  },
  {
    title: "Vos droits (RGPD)",
    body: "Vous disposez d'un droit d'accès, de rectification, d'effacement, de limitation et d'opposition concernant vos données. Pour les exercer : maryannagasper@gmail.com. Vous pouvez également saisir la CNIL (cnil.fr) en cas de litige.",
  },
  {
    title: "Cookies",
    body: "Le site utilise uniquement des cookies techniques nécessaires à la connexion des professionnels et de l'administratrice (cookies httpOnly). Aucun cookie publicitaire ou de mesure d'audience tiers n'est déposé.",
  },
  {
    title: "Sous-traitants",
    body: "Envoi d'emails transactionnels : Resend (via la plateforme Emergent). Hébergement : Emergent (infrastructure cloud Kubernetes). Base de données : MongoDB hébergée sur la même infrastructure.",
  },
];

export default function LegalPage() {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="max-w-3xl mx-auto px-4 md:px-8 py-12">
        <h1 data-testid="legal-title" className="text-3xl sm:text-4xl font-extrabold tracking-tight text-[#1F2937]" style={{ fontFamily: "Manrope" }}>
          Confidentialité &amp; mentions légales
        </h1>
        <p className="text-base text-[#6B7280] mt-3">
          Dernière mise à jour : août 2026. Lantouraj s'engage à ne collecter que le strict nécessaire.
        </p>
        <div className="mt-10 flex flex-col gap-8">
          {sections.map((s, i) => (
            <section key={s.title} data-testid={`legal-section-${i}`} className="bg-white rounded-xl border border-black/5 p-6">
              <h2 className="text-lg font-bold text-[#0D4045]" style={{ fontFamily: "Manrope" }}>{s.title}</h2>
              <p className="text-sm text-[#1F2937]/85 leading-relaxed mt-2">{s.body}</p>
            </section>
          ))}
        </div>
      </main>
    </div>
  );
}
